/*
 *
 * TemplatePreviewPage constants
 *
 */

export const FETCH_TEMPLATE_PREVIEW =
  'app/TemplatePreviewPage/FETCH_TEMPLATE_PREVIEW';
export const FETCH_TEMPLATE_PREVIEW_SUCCESS =
  'app/TemplatePreviewPage/FETCH_TEMPLATE_PREVIEW_SUCCESS';
export const FETCH_TEMPLATE_PREVIEW_ERROR =
  'app/TemplatePreviewPage/FETCH_TEMPLATE_PREVIEW_ERROR';

export const CREATE_FROM_TEMPLATE =
  'app/TemplatePreviewPage/CREATE_FROM_TEMPLATE';
export const CREATE_FROM_TEMPLATE_SUCCESS =
  'app/TemplatePreviewPage/CREATE_FROM_TEMPLATE_SUCCESS';
export const CREATE_FROM_TEMPLATE_ERROR =
  'app/TemplatePreviewPage/CREATE_FROM_TEMPLATE_ERROR';

export const TEMPLATE_MOBILE_VIEWPORT = 800;

export const FIELD_TYPE = {
  TEXT: 'text',
  TEXT_ARRAY: 'textArray',
  TEXT_WITH_MEDIA: 'textWithMedia',
  TEXT_WITH_MEDIA_REPEATER: 'textWithMediaRepeater',
  NUMERIC: 'numeric',
  TEXT_REPEATER: 'textRepeater',
  CONCEPT_REPEATER: 'conceptRepeater',
  ATTRIBUTE_REPEATER: 'attributeRepeater',
  BOOLEAN: 'boolean',
  BOOLEAN_TOGGLE: 'booleanToggle',
  NUMBER: 'number',
  TEXT_WITH_NUMERIC: 'textWithNumeric',
  SCHEDULER: 'scheduler',
  ATTRIBUTE: 'attribute',
  CARD: 'card',
};
